import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { Box } from '@mui/material';

interface Props {
	onLoad?: (content: any) => void;
}

export const HEADER_CATEGORY_TEMPORAL_SPOT = 'DPSV2HeaderCategoryTemporal';

export const HeaderCategoryTemporal: React.FC<Props> = ({ onLoad }) => (
	<ContentRecommendation
		id={HEADER_CATEGORY_TEMPORAL_SPOT}
		properties={{
			emsName: HEADER_CATEGORY_TEMPORAL_SPOT,
		}}
		loadingElement={<Box />}
		withoutFrame={true}
		onLoad={onLoad}
	/>
);
